import { createBrowserRouter } from "react-router-dom";
import Layouts from "../pages/Layouts";
import { lazy, Suspense } from "react";
import PermissionGuard, { DefaultRedirect } from "../component/PermissionGuard";
import Loading from "../component/Loading";
import NoPermission from "../pages/NoPermission";

const EventLibrary = lazy(() => import("../pages/EventManager"));
const TimelineTemplate = lazy(() => import("../pages/TimelineTemplate"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layouts />,
    children: [
      {
        index: true,
        element: <DefaultRedirect />,
      },
      {
        path: "event-library",
        element: (
          <PermissionGuard permission="operate_event_library">
            <Suspense fallback={<Loading open />}>
              <EventLibrary />
            </Suspense>
          </PermissionGuard>
        ),
      },
      {
        path: "timeline-template",
        element: (
          <PermissionGuard permission="operate_timeline_template">
            <Suspense fallback={<Loading open />}>
              <TimelineTemplate />
            </Suspense>
          </PermissionGuard>
        ),
      },
    ],
  },
  {
    path: "no-permission",
    element: <NoPermission />,
  },
  {
    path: "*",
    element: <NoPermission />,
  },
]);

export { router };

